import { useState } from 'react';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function Testimonials() {
  const { ref, isVisible } = useScrollAnimation<HTMLElement>();

  const testimonials = [
    {
      quote: "The team at unuu have scaled our online presence by launching a fresh corporate brand and delivering consistently high-quality, compliant content for our brokers. The volume and quality of daily posts mean that every visitor is met with a strong, professional first impression.",
      author: "Mark Ninnim",
      title: "Marketing Director - The Finance Planning Group",
      image: "https://public.readdy.ai/ai/img_res/7c032fc7339f7337343ed78980952996.jpg"
    },
    {
      quote: "We were skeptical about TikTok for our B2B brand, but SocialSpark proved us wrong. Their creative team produced content that went viral multiple times, generating over 2 million views and 500+ qualified leads in one quarter.",
      author: "Marcus Chen",
      title: "CMO, TechFlow Solutions",
      image: "https://readdy.ai/api/search-image?query=Professional%20Asian%20man%20executive%20in%20his%2040s%20confident%20smile%2C%20business%20casual%20attire%20blazer%2C%20natural%20lighting%20portrait%20photography%2C%20clean%20warm%20coral%20tinted%20background%2C%20authentic%20genuine%20expression%20showing%20leadership&width=400&height=500&seq=testimonial-marcus-2&orientation=portrait"
    },
    {
      quote: "The influencer campaign they ran for our product launch exceeded every expectation. 50 creators, 10 million impressions, and we sold out our entire inventory in 48 hours. SocialSpark is now our permanent marketing partner.",
      author: "Sarah Mitchell",
      title: "Brand Director, Luxe Athletics",
      image: "https://readdy.ai/api/search-image?query=Professional%20woman%20marketing%20director%20in%20her%2030s%20confident%20smile%2C%20stylish%20business%20attire%2C%20natural%20lighting%20portrait%20photography%2C%20clean%20warm%20coral%20tinted%20background%2C%20authentic%20genuine%20expression%20showing%20confidence&width=400&height=500&seq=testimonial-sarah-3&orientation=portrait"
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  return (
    <section
      ref={ref}
      className={`py-32 bg-[#00989e]/5 transition-all duration-700 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-5 gap-12 items-center">
          <div className={`lg:col-span-2 transition-all duration-700 delay-100 ${
            isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'
          }`}>
            <div className="rounded-3xl overflow-hidden h-[500px] w-full">
              <img
                src={testimonials[currentIndex].image}
                alt={testimonials[currentIndex].author}
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className={`lg:col-span-3 transition-all duration-700 delay-200 ${
            isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8'
          }`}>
            <div className="mb-6">
              <span className="text-xs uppercase tracking-wider text-gray-500 font-medium">
                (Client Success Story)
              </span>
            </div>
            <h2 className="text-5xl font-bold text-slate-900 mb-16" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Real Results, <span className="text-gray-400">Real Growth</span>
            </h2>

            <blockquote className="mb-12">
              <p className="text-xl text-gray-700 leading-relaxed mb-8">
                "{testimonials[currentIndex].quote}"
              </p>
              <footer>
                <div className="font-bold text-slate-900 text-lg">
                  — {testimonials[currentIndex].author}
                </div>
                <div className="text-gray-600 mt-1">
                  {testimonials[currentIndex].title}
                </div>
              </footer>
            </blockquote>

            <div className="flex gap-4">
              <button
                onClick={handlePrev}
                className="w-12 h-12 rounded-full border-2 border-gray-300 flex items-center justify-center hover:border-slate-900 hover:bg-slate-900 hover:text-white transition-all cursor-pointer"
              >
                <i className="ri-arrow-left-line"></i>
              </button>
              <button
                onClick={handleNext}
                className="w-12 h-12 rounded-full bg-slate-900 text-white flex items-center justify-center hover:bg-slate-800 transition-all cursor-pointer"
              >
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
